var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { sanitize } from "dompurify";
import { lighten, Stack } from "@mui/material";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { Text, Tooltip } from "../../../../Atoms";
import { COLORS } from "../../../../../constants";
var badgeStyles = {
    background: COLORS.WHITE,
    py: 2,
    px: 2,
    borderRadius: 2,
    border: "1px solid ".concat(COLORS.P_OUTLINE),
};
var UserCell = function (_a) {
    var isDeletedUser = _a.isDeletedUser, userName = _a.userName, profileColor = _a.profileColor, useBadgeStyles = _a.useBadgeStyles, numTags = _a.numTags, Icon = _a.Icon, tooltip = _a.tooltip, columnName = _a.columnName, id = _a.id, iconSize = _a.iconSize, color = _a.color, initials = _a.initials, asHTML = _a.asHTML;
    var bgcolor = profileColor ? profileColor : COLORS.SATURATED_BLUE;
    if (isDeletedUser) {
        bgcolor = COLORS.P_DISABLED;
    }
    var iconStyle = useMemo(function () { return ({
        color: color,
        ml: 2,
        width: iconSize,
        height: iconSize,
        display: "block",
    }); }, [iconSize]);
    return (_jsxs(Stack, __assign({ direction: "row", alignItems: "center", "data-testid": "".concat(userName, "-user-cell"), sx: useBadgeStyles ? badgeStyles : undefined }, { children: [_jsx(Stack, __assign({ bgcolor: bgcolor, borderRadius: "50%", width: 24, height: 24, minWidth: 24, minHeight: 24, alignItems: "center", justifyContent: "center" }, { children: isDeletedUser ? (_jsx(PersonOffIcon, { "data-testid": "deleted-user", sx: { color: COLORS.WHITE, width: "16px", height: "16px" } })) : (_jsx(Text, __assign({ variant: "caption", shade: "light" }, { children: initials }))) })), asHTML ? (_jsx(Text, { variant: "body2", ml: 3, sx: {
                    wordBreak: "break-word",
                }, "data-testid": "user-cell-htmlname", dangerouslySetInnerHTML: { __html: sanitize(userName) } })) : (_jsx(Text, __assign({ variant: "body2", sx: {
                    wordBreak: "break-word",
                }, "data-testid": "user-cell-name", ml: 3 }, { children: userName }))), numTags ? (_jsx(Stack, __assign({ alignItems: "center", width: "24px", height: "16px", ml: 2, "data-testid": "user-tags", bgcolor: lighten(COLORS.SAY_COBALT, 0.88), borderRadius: 3 }, { children: _jsx(Text, __assign({ variant: "caption", emphasis: "medium" }, { children: numTags })) }))) : null, !!Icon && (_jsx(Tooltip, __assign({ "data-testid": "tooltip-".concat(columnName, "-").concat(id), title: tooltip }, { children: _jsx(Icon, { "data-testid": "usercell-icon", sx: iconStyle }) })))] })));
};
export default React.memo(UserCell);
